import { createAsyncThunk } from "@reduxjs/toolkit";
import { http } from "../../utils/config";

// Tạo async thunk để lấy danh sách dịch vụ từ API
export const getListMapServiceBranch = createAsyncThunk(
    "mapServiceBranch/getListMapServiceBranch",
    async ({ currentPage, pageSize}, { rejectWithValue }) => {
        try {
            let apiUrl = `/api/v1/serviceconnect/map-service-branch?has_paginate&size=${pageSize}&page=${currentPage}`;
            const response = await http.get(apiUrl);
            return response.data;
        } catch (error) {
            return rejectWithValue("Có lỗi xảy ra trong quá trình kết nối");
        }
    }
);

export const updateMapServiceBranch = createAsyncThunk(
  "mapServiceBranch/updateMapServiceBranch",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await http.put(`/api/v1/serviceconnect/map-service-branch/${id}`, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const createMapServiceBranch = createAsyncThunk(
  "mapServiceBranch/createMapServiceBranch",
  async (data, { rejectWithValue }) => {
    try {
      const response = await http.post(`/api/v1/serviceconnect/map-service-branch`, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const deleteMapServiceBranch = createAsyncThunk(
  "mapServiceBranch/deleteMapServiceBranch",
  async (id, { rejectWithValue }) => {
    try {
      const response = await http.delete(`/api/v1/serviceconnect/map-service-branch/${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const statusMapServiceBranch = createAsyncThunk(
  "mapServiceBranch/statusMapServiceBranch", 
  async ({ id, data }, { rejectWithValue }) => { 
    try {
      const response = await http.put(`/api/v1/serviceconnect/map-service-branch/status/${id}`, data); // Gọi API PUT
      return response.data; 
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);